import authenticationServiceApi from '../api/authentication.service.api';
import { updateToken } from '../store/actions/auth.actions';
import { ServiceBase } from './service.base';

class AuthService extends ServiceBase {
  /**
   * Refresh access token
   * @returns Boolean - true if succeeded
   * @memberof AuthService
   */
  async refreshToken() {
    const { auth, organization } = this.state;
    const refreshToken = auth?.refreshToken || null;
    const userId = auth?.user?.id || auth?.id || auth?.refreshTokenDetails.id || null;
    const organizationId =
      organization?.id ||
      auth?.user?.organizationId ||
      auth?.organizationId ||
      auth?.refreshTokenDetails?.organizationId ||
      null;

    let data;
    try {
      const res = await authenticationServiceApi.refreshToken({
        refreshToken,
        userId,
        organizationId,
      });

      data = res?.data;

      if (res.error) {
        console.log(`Fail to refresh access token - ${data.message}`);
        return false;
      }
    } catch (e) {
      console.log(`Fail to refresh access token - ${e}`);
      return false;
    }

    console.log('Token refresh - Succeeded');

    this.dispatch(updateToken(data));
    return true;
  }
}
export default new AuthService();
